import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { createLogger } from "redux-logger";
import RootReducer from "./redux/reducers";
import { Provider } from "react-redux";
import Auth from "./Auth";
import "./security/http";
const loggerMiddleware = createLogger({
  predicate: () => process.env.NODE_ENV === "development",
});
const middleware = applyMiddleware(thunk, loggerMiddleware);
const store = createStore(RootReducer, {}, middleware);
//alert("Calling index");
Auth.caching();

ReactDOM.render(
  //<Provider store={store}>
  <App />,
  // </Provider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
